export function signUpDiagnostic(attempt: { status: string | null; missingFields: readonly string[] }): string {
  const missing = attempt.missingFields.length ? attempt.missingFields.join(",") : "none";
  return `status=${attempt.status ?? "null"} missingFields=${missing}`;
}

/** True when the only gaps left can be filled with the password already collected and the mounted captcha. */
export function canSupplySignUp(attempt: { missingFields: readonly string[]; unverifiedFields: readonly string[] }): boolean {
  const missingOk = attempt.missingFields.every((field) => field === "password" || field.toLowerCase().includes("captcha"));
  const unverifiedOk = attempt.unverifiedFields.every((field) => field === "email_address");
  if (!missingOk || !unverifiedOk) return false;
  const needsPassword = attempt.missingFields.includes("password");
  const captchaOnly = attempt.missingFields.some((field) => field.toLowerCase().includes("captcha"));
  const nothingElse = attempt.missingFields.length === 0;
  return needsPassword || captchaOnly || nothingElse;
}
